module.exports = __webpack_public_path__ + "media/images/village/sony-talent-league-edition-ii/icons-86b5cb3b41d5ebb3a7397ef089cd6370.svg";